import Header from '@/components/common/Header.vue';
import { defineComponent } from 'vue';
import trainItem from '@/components/list/trainItem.vue';
import { meetReq } from '@/api/index';
import Empty from '@/components/common/Empty.vue';
import { getMoreList } from '@/api/home';
import { getTabFlag } from '@/api/meeting';
import { getUserId, appPort } from '@/widget';
export default defineComponent({
    data() {
        return {
            unlockType: '',
            isComing: true,
            isMine: false,
            flag: true,
            list: [],
            title: ' 线上共学营',
            pageNo: 1,
            pageCount: 1,
            isOperation: 3,
            isApp: appPort(),
            scroll: false,
            kw: this.$route.query.keyword,
            totalCount: 0,
            typeList: [],
            typeId: 0,
            freeModeDataFlag: true,
            comingDataFlag: true // 即将召开有数据
        };
    },
    mounted() {
        getTabFlag({
            userId: getUserId()
        }).then(res => {
            if (res.code === 200) {
                this.getTypeList();
                // console.log(res.data)
                // 即将召开有数据
                this.comingDataFlag = res.data.comingDataFlag;
                // 随到随学有数据
                this.freeModeDataFlag = res.data.freeModeDataFlag;
                if (this.comingDataFlag ||
                    (this.comingDataFlag && this.freeModeDataFlag)) {
                    this.isComing = true;
                    this.changeTab(true);
                    return;
                }
                if (this.freeModeDataFlag ||
                    (!this.comingDataFlag && !this.freeModeDataFlag)) {
                    this.unlockType = '3';
                    this.unlockTypeTab();
                }
            }
        });
    },
    methods: {
        // 切换往期、即将
        changeTab(bl) {
            if (this.flag) {
                this.unlockType = '';
                this.isComing = bl;
                this.pageNo = 1;
                this.list = [];
                this.typeList = [];
                this.typeId = 0;
                this.getTypeList();
                this.getList();
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        },
        // 切换随到随学
        unlockTypeTab() {
            if (this.flag) {
                this.unlockType = '3';
                this.isComing = null;
                this.pageNo = 1;
                this.list = [];
                this.typeList = [];
                this.typeId = 0;
                this.getTypeList();
                this.getList();
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        },
        // 切换类别
        changeType(typeId) {
            if (this.flag) {
                this.typeId = typeId;
                this.pageNo = 1;
                this.list = [];
                this.getList();
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        },
        // 切换仅显示我报名的
        changeIsMine() {
            if (this.flag) {
                this.isMine = !this.isMine;
                this.pageNo = 1;
                this.list = [];
                this.getList();
            }
            else {
                this.$toast('数据加载中，请稍后');
            }
        },
        /**
         * 获取分类
         */
        getTypeList() {
            meetReq
                .getTypeList({
                params: { userId: getUserId() },
                query: this.unlockType
                    ? { isOperation: this.isOperation, unlockType: this.unlockType }
                    : { isOperation: this.isOperation, isComing: this.isComing }
            })
                .then(res => {
                if (res.code === 200) {
                    this.typeList = res.data;
                }
                else {
                    this.$toast(res.message);
                }
                this.flag = true;
            })
                .catch(() => {
                this.$toast('请求失败，请刷新页面试试');
            });
        },
        /**
         * 获取列表
         */
        getList() {
            if (!this.flag) {
                return;
            }
            this.flag = false;
            let { kw, pageNo } = this;
            if (kw) {
                getMoreList({
                    type: 'onlineOperation',
                    userId: getUserId(),
                    pageNo: pageNo
                }, {
                    kw,
                    pageNo
                }).then(res => {
                    if (res.code === 200) {
                        // 未加载完成可以继续加载
                        this.pageCount = res.data.pageCount;
                        // 是否需要上拉加载
                        if (this.pageCount > 1) {
                            this.scrollToBottom();
                        }
                        if (this.pageNo === 1) {
                            this.list = res.data.list;
                        }
                        else {
                            this.list = this.list.concat(res.data.list);
                        }
                    }
                    else {
                        this.$toast(res.message);
                    }
                    this.flag = true;
                });
                return;
            }
            const query = {
                pageNo: this.pageNo,
                isMine: this.isMine,
                isOperation: this.isOperation,
                typeId: this.typeId
            };
            meetReq
                .getMeetingList({
                params: {
                    userId: getUserId()
                },
                query: this.unlockType
                    ? { unlockType: this.unlockType, ...query }
                    : { isComing: this.isComing, ...query }
            })
                .then(res => {
                if (res.code === 200) {
                    // 未加载完成可以继续加载
                    this.pageCount = res.data.pageCount;
                    // 是否需要上拉加载
                    if (this.pageCount > 1) {
                        this.scrollToBottom();
                    }
                    if (this.pageNo === 1) {
                        this.list = res.data.list;
                    }
                    else {
                        this.list = this.list.concat(res.data.list);
                    }
                    this.totalCount = res.data.totalCount;
                }
                else {
                    this.$toast(res.message);
                }
                this.flag = true;
            });
        },
        // 页面触底判断
        scrollToBottom() {
            document.addEventListener('scroll', this.requestMore, false);
        },
        requestMore() {
            var scrollHigh = document.documentElement.scrollTop || document.body.scrollTop;
            // 距离底部200px时触发
            if (scrollHigh + window.innerHeight >= document.body.clientHeight - 200) {
                this.scrollCallBack();
            }
        },
        scrollCallBack() {
            if (this.pageCount > this.pageNo && this.flag) {
                this.pageNo = this.pageNo + 1;
                this.getList();
            }
        }
    },
    unmounted() {
        document.removeEventListener('scroll', this.requestMore, false);
    },
    components: {
        Header,
        trainItem,
        Empty
    }
});
